import React from "react";
import "./BenefitsCards.css";

const cardData = [
  {
    label: "성공적인 출판",
    value: "2,100",
    unit: "종 +",
  },
  {
    label: "고객만족도",
    value: "98",
    unit: "%",
  },
  {
    label: "출판 전문 경험",
    value: "30",
    unit: "년",
  },
  {
    label: "맞춤형 출판 방식",
    value: "4",
    unit: "가지",
  },
];

const BenefitsCards = () => {
  return (
    <section className="benefits-cards-section">
      {cardData.map((card, index) => (
        <div className="benefits-card" key={index}>
          <p className="card-label">{card.label}</p>
          <h1 className="card-value">
            {card.value}
            <span className="card-unit">{card.unit}</span>
          </h1>
        </div>
      ))}
    </section>
  );
};

export default BenefitsCards;
